import { Response } from '@marketplace-web/shared/api-client'
import { transformCurrencyAmountDto } from '@marketplace-web/domain/currency-data'

import {
  BumpMinimumPriceDto,
  BumpMinimumPriceModel,
  BumpMinimumPriceResp,
} from '../types/bump-minimum-price'

export const transformBumpMinimumPrice = (dto: BumpMinimumPriceDto): BumpMinimumPriceModel => ({
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
  discount: transformCurrencyAmountDto(dto.discount),
  hasFreeBump: dto.has_free_bump,
})

export const transformBumpMinimumPriceResponse = (response: Response<BumpMinimumPriceResp>) =>
  transformBumpMinimumPrice(response.minimum_price)
